import React from 'react';
import { useTranslation } from 'react-i18next';
import './Page.css';

const Nauczanie = () => {
  const { t } = useTranslation();
  
  return (
    <div className="page">
      <div className="page-container">
        <div className="page-header">
          <h1>{t('teaching.title')}</h1>
          <p className="page-subtitle">{t('teaching.subtitle')}</p>
        </div>
        
        <div className="page-content">
          <div className="content-section">
            <h2>{t('teaching.methodology')}</h2>
            <p>
              {t('teaching.methodologyText')}
            </p>
          </div>
          
          <div className="content-section">
            <h2>{t('teaching.scope')}</h2>
            <ul className="teaching-list">
              {t('teaching.scopeItems', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          
          <div className="content-section">
            <h2>{t('teaching.experience')}</h2>
            <p>
              {t('teaching.experienceText')}
            </p>
          </div>
          
          <div className="content-section">
            <h2>{t('teaching.formats')}</h2>
            <p>
              {t('teaching.formatsDesc')}
            </p>
            <p>
              {t('teaching.formatsText')}
            </p>
            <p>
              {t('teaching.formatsText2')}
            </p>
            <div className="teaching-options">
              <div className="option">
                <h3>{t('teaching.individual')}</h3>
                <p>{t('teaching.individualDesc')}</p>
              </div>
              <div className="option">
                <h3>{t('teaching.group')}</h3>
                <p>{t('teaching.groupDesc')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nauczanie;
